import { timeParse } from 'd3'

const leverageChartData = [
    {
        "dateString": "2010-12-31",
        "debt_over_mcap_deviation": "",
        "debt_over_mcap_h_deviation": "0.383750649",
        "chart_name": "Leverage (Net Debt / Market Cap)",
        "chart_number": "2"
    },
    {
        "dateString": "2011-06-30",
        "debt_over_mcap_deviation": "",
        "debt_over_mcap_h_deviation": "0.321404641",
        "chart_name": "Leverage (Net Debt / Market Cap)",
        "chart_number": "2"
    },
    {
        "dateString": "2011-12-31",
        "debt_over_mcap_deviation": "",
        "debt_over_mcap_h_deviation": "",
        "chart_name": "Leverage (Net Debt / Market Cap)",
        "chart_number": "2"
    },
    {
        "dateString": "2012-06-30",
        "debt_over_mcap_deviation": "",
        "debt_over_mcap_h_deviation": "0.420152407",
        "chart_name": "Leverage (Net Debt / Market Cap)",
        "chart_number": "2"
    },
    {
        "dateString": "2012-12-31",
        "debt_over_mcap_deviation": "",
        "debt_over_mcap_h_deviation": "0.390358142",
        "chart_name": "Leverage (Net Debt / Market Cap)",
        "chart_number": "2"
    },
    {
        "dateString": "2013-06-30",
        "debt_over_mcap_deviation": "",
        "debt_over_mcap_h_deviation": "0.178254047",
        "chart_name": "Leverage (Net Debt / Market Cap)",
        "chart_number": "2"
    },
    {
        "dateString": "2013-12-31",
        "debt_over_mcap_deviation": "-1.779382369",
        "debt_over_mcap_h_deviation": "-0.044634004",
        "chart_name": "Leverage (Net Debt / Market Cap)",
        "chart_number": "2"
    },
    {
        "dateString": "2014-06-30",
        "debt_over_mcap_deviation": "-0.855216891",
        "debt_over_mcap_h_deviation": "-0.027680282",
        "chart_name": "Leverage (Net Debt / Market Cap)",
        "chart_number": "2"
    },
    {
        "dateString": "2014-12-31",
        "debt_over_mcap_deviation": "-1.005129537",
        "debt_over_mcap_h_deviation": "-0.067471755",
        "chart_name": "Leverage (Net Debt / Market Cap)",
        "chart_number": "2"
    },
    {
        "dateString": "2015-06-30",
        "debt_over_mcap_deviation": "-0.129958637",
        "debt_over_mcap_h_deviation": "0.01177133",
        "chart_name": "Leverage (Net Debt / Market Cap)",
        "chart_number": "2"
    },
    {
        "dateString": "2015-12-31",
        "debt_over_mcap_deviation": "0.423692775",
        "debt_over_mcap_h_deviation": "-0.094817311",
        "chart_name": "Leverage (Net Debt / Market Cap)",
        "chart_number": "2"
    },
    {
        "dateString": "2016-06-30",
        "debt_over_mcap_deviation": "1.90020101",
        "debt_over_mcap_h_deviation": "-0.117944671",
        "chart_name": "Leverage (Net Debt / Market Cap)",
        "chart_number": "2"
    },
    {
        "dateString": "2016-12-31",
        "debt_over_mcap_deviation": "0.485015521",
        "debt_over_mcap_h_deviation": "-0.07126984",
        "chart_name": "Leverage (Net Debt / Market Cap)",
        "chart_number": "2"
    },
    {
        "dateString": "2017-06-30",
        "debt_over_mcap_deviation": "0.993727602",
        "debt_over_mcap_h_deviation": "-0.052774184",
        "chart_name": "Leverage (Net Debt / Market Cap)",
        "chart_number": "2"
    },
    {
        "dateString": "2017-12-31",
        "debt_over_mcap_deviation": "0.122712501",
        "debt_over_mcap_h_deviation": "-0.06991956",
        "chart_name": "Leverage (Net Debt / Market Cap)",
        "chart_number": "2"
    },
    {
        "dateString": "2018-06-30",
        "debt_over_mcap_deviation": "0.397725597",
        "debt_over_mcap_h_deviation": "-0.072320069",
        "chart_name": "Leverage (Net Debt / Market Cap)",
        "chart_number": "2"
    },
    {
        "dateString": "2018-12-31",
        "debt_over_mcap_deviation": "0.224870205",
        "debt_over_mcap_h_deviation": "-0.167213551",
        "chart_name": "Leverage (Net Debt / Market Cap)",
        "chart_number": "2"
    },
    {
        "dateString": "2019-06-30",
        "debt_over_mcap_deviation": "0.660021843",
        "debt_over_mcap_h_deviation": "-0.245244638",
        "chart_name": "Leverage (Net Debt / Market Cap)",
        "chart_number": "2"
    },
    {
        "dateString": "2019-12-31",
        "debt_over_mcap_deviation": "-0.042770034",
        "debt_over_mcap_h_deviation": "-0.281602909",
        "chart_name": "Leverage (Net Debt / Market Cap)",
        "chart_number": "2"
    },
    {
        "dateString": "2020-06-30",
        "debt_over_mcap_deviation": "2.576390399",
        "debt_over_mcap_h_deviation": "-0.271418814",
        "chart_name": "Leverage (Net Debt / Market Cap)",
        "chart_number": "2"
    }
]

const parseDate = timeParse('%Y-%m-%d')

export default leverageChartData.map(d => {
  d['date'] = parseDate(d['dateString'])
  return d
})
